import { Component, inject } from '@angular/core';
import { TractorAttachmentPerTractorService } from '../proxy/general/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  TractorAttachmentPerTractorCreateDto,
  TractorAttachmentPerTractorDto,
  TractorAttachmentPerTractorExcelDownloadDto,
  TractorAttachmentPerTractorUpdateDto,
} from '../proxy/general/dtos/tractor-attachment-per-tractor';
import { TRACTORATTACHMENTPERTRACTOR_CONFIG, TRACTORATTACHMENTPERTRACTOR_FIELDS } from './tractor-attachment-per-tractor.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tractor-attachment-per-tractor',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, TractorAttachmentPerTractorService, ConfirmationService],
  templateUrl: './tractor-attachment-per-tractor.html',
  styleUrl: './tractor-attachment-per-tractor.scss',
})
export class TractorAttachmentPerTractor extends BaseHierarchicalCrudComponent<
  TractorAttachmentPerTractorDto,
  TractorAttachmentPerTractorCreateDto,
  TractorAttachmentPerTractorUpdateDto,
  TractorAttachmentPerTractorExcelDownloadDto
> {
  service = inject(TractorAttachmentPerTractorService);
  config = TRACTORATTACHMENTPERTRACTOR_CONFIG;
  fields = TRACTORATTACHMENTPERTRACTOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: TractorAttachmentPerTractorDto): TractorAttachmentPerTractorUpdateDto {
    return {
      tractorId: data.tractorId,
      tractorAttachmentId: data.tractorAttachmentId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'TractorAttachmentPerTractor';
  }
}
